export const baseUrl = "https://alumniapi.cuet.ac.bd/api/v1";
export const imageUrl = "https://alumniapi.cuet.ac.bd";
// export const baseUrl = "http://127.0.0.1:8000/api/v1";
// export const imageUrl = "http://127.0.0.1:8000";